"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/values"));
var _react = _interopRequireWildcard(require("react"));
var _intl = require("@kyruus/intl");
var _startCase = _interopRequireDefault(require("lodash/startCase"));
var _styles = require("./styles");
var _provider = require("../../lib/provider");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProviderSummary = _ref => {
  let {
    provider,
    summaryData,
    facets
  } = _ref;
  /**
   * An object representing summary data for a provider.
   * @typedef {Object} SummaryFieldValue
   * @property {string | number} primary The primary value of this field.
   * @property {(string | number)[] | undefined} secondary An optional secondary value of this field.
   * @property {string} list_type A string indicating how to render; alway set to 'hierarchy' if secondary is present.
   */

  /**
   * Creates the contents for a column list
   * @param {SummaryFieldValue[]} values The values for the summary column
   * @return {JSX[]} An array of elements for the column list
   */
  const summaryColumnListCreator = values => {
    const elements = [];
    for (const value of values) {
      if (value.list_type === _provider.LIST_TYPE.HIERARCHY) {
        var _context;
        const secondaryValues = (0, _map.default)(_context = value.secondary).call(_context, secondaryValue => {
          return /*#__PURE__*/_react.default.createElement(_styles.SummaryColumnSubItem, {
            key: secondaryValue,
            renderType: value.render_type
          }, secondaryValue);
        });
        let primaryText = `${value.primary}`;
        if (secondaryValues.length && value.render_type === _provider.LIST_RENDER_TYPE.HIERARCHY) {
          primaryText = `${value.primary}:`;
        }
        elements.push(/*#__PURE__*/_react.default.createElement(_styles.SummaryColumnItem, {
          key: value.primary
        }, primaryText));
        if (secondaryValues.length) {
          elements.push(/*#__PURE__*/_react.default.createElement(_styles.SummaryColumnSublist, {
            key: `${value.primary}-sub`,
            renderType: value.render_type
          }, secondaryValues));
        }
      } else {
        elements.push(/*#__PURE__*/_react.default.createElement(_styles.SummaryColumnItem, {
          key: value.primary
        }, value.primary));
      }
    }
    return elements;
  };

  /**
   * Creates the column container, header and list for a summary field.
   * @param {object} field The object describing a provider summary.
   * @return {JSX} A summary column for the passed in summary field.
   */
  const summaryColumnCreator = field => {
    const fieldLabelMessageDescriptor = {
      id: `field.name.${field.field}`,
      defaultMessage: (0, _startCase.default)(field.field),
      description: 'The title displayed above the summary field'
    };
    return !!(0, _values.default)(field).length && /*#__PURE__*/_react.default.createElement(_styles.SummaryColumn, {
      key: field.field
    }, /*#__PURE__*/_react.default.createElement(_styles.SummaryColumnHeader, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, fieldLabelMessageDescriptor)), /*#__PURE__*/_react.default.createElement(_styles.SummaryColumnList, null, summaryColumnListCreator((0, _values.default)(field))));
  };

  // Get the summary for the provider
  const summary = (0, _react.useMemo)(() => (0, _provider.getProviderSummaryFields)(provider, summaryData, facets), [provider, summaryData, facets]);
  return /*#__PURE__*/_react.default.createElement(_styles.SummaryContainer, {
    "data-testid": "ProviderSummaryFields"
  }, (0, _map.default)(summary).call(summary, summaryColumnCreator));
};
var _default = exports.default = ProviderSummary;
ProviderSummary.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderSummary"
};